import { Tooltip } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWarning } from '@fortawesome/free-solid-svg-icons'
import { ContainerIconeInconsistencia } from './styled'

//PROPS
interface Props {
    /**Motivo da inconsistência, exatamente como a API devolveu no campo `inconsistencia` */
    texto: string
}

/**Marca a linha da tabela como inconsistente sem ocupar uma coluna: o ícone entra em
 * uma célula que já existe e o motivo fica no tooltip
*/
export const IconeInconsistencia: React.FC<Props> = ({ texto }) => {

    return (
        <Tooltip
            trigger='hover'
            placement='right'
            color='#fff'
            overlayInnerStyle={{
                color: '#000',
                padding: 12,
                borderRadius: 8,
                maxWidth: 320,
                // o motivo pode vir com mais de uma linha, então as quebras são preservadas
                whiteSpace: 'pre-line',
            }}
            title={texto}
        >
            <ContainerIconeInconsistencia>
                <FontAwesomeIcon icon={faWarning} />
            </ContainerIconeInconsistencia>
        </Tooltip>
    )
}
